import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
}), 'ShortTextSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ShortTextSharp.js
// module id = 6116
// module chunks = 2